export default "__VITE_ASSET__Pg2hiHbx__"